import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3fd1d22e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3fd1d22e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd1d22e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fd1d22e')) {
      api.createRecord('3fd1d22e', component.options)
    } else {
      api.reload('3fd1d22e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3fd1d22e&scoped=true&", function () {
      api.rerender('3fd1d22e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channel/all/index.vue"
export default component.exports